import { ExternalLink, CheckCircle2 } from "lucide-react";
import { Button } from "@components/ui/button";
import { VariantCard } from "@academy-context/primary/shared/external-provider-batch-display/variant-card.content";
import type { SubcontractingContract } from "@shared-kernel/application/ports/external-provider/external-provider-repository";
import { formatDateToLocale } from "@utils/formatting";
import backendConfig from "@config/backend";
import type { Nullable } from "@shared-kernel/core/types/nullable";

interface Props {
  // Null right after an optimistic signature, until the dashboard is refetched
  contract: Nullable<SubcontractingContract>;
}

export const SignedContractCard = ({ contract }: Props) => {
  const downloadUrl = contract?.downloadEndpoint ? `${backendConfig.url}${contract.downloadEndpoint}` : null;

  return (
    <VariantCard variant="provider" title="Contrat de sous-traitance">
      <div className="space-y-3">
        <p className="flex items-start gap-2 text-sm text-green-700">
          <CheckCircle2 className="mt-0.5 size-4 shrink-0" />
          Le contrat a été signé{contract?.signedAt ? ` le ${formatDateToLocale(contract.signedAt)}` : ""}
        </p>
        {downloadUrl && (
          <Button asChild variant="outline" size="sm">
            <a href={downloadUrl} target="_blank" rel="noopener noreferrer">
              <ExternalLink className="mr-2 size-4" />
              Télécharger {contract?.name}
            </a>
          </Button>
        )}
      </div>
    </VariantCard>
  );
};
